import React from "react";

const bounceDoc = (
    <>
        <p>
            Triggers entry tactics on a bounce off a price.
        </p>
        <p>
            Ex: If AAPL is currently at 451, we can buy on a bounce at 450. If AAPL is
            currently at 449, we can short on a bounce at 450.
        </p>
        <p>
            NOTE: we attempt to validate the sensibility of the bounce, by terminating
            the Trade Plan if the bounce has already passed.
            For example, if you try to go long on a bounce at 450 when AAPL is at 449,
            the Trade Plan will be cancelled.
        </p>
    </>
);
export default bounceDoc;
